import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';
import { getAvailableProducts, getOpenPlatformProducts } from './products.selectors';
import { getFilteredUnloadTypes, getPumpabilities, getUnloadTypes } from './single-catalogs';

export const getAddedValuesState = createSelector(getRmsSpecificationPage, (state) => state.addedValuesLegacyState);
export const getAddedValuesOpenPlatformState = createSelector(
  getRmsSpecificationPage,
  (state) => state.addedValuesOpenPlatformState,
);

export const getAvailableAddedValues = createSelector(getAddedValuesState, (state) => state.availableAddedValues);

export const getAvailableOpenPlatformAddedValues = createSelector(
  getAddedValuesOpenPlatformState,
  (state) => state.availableAddedValues,
);

export const getOPAddedValuesAndPumpabilities = createSelector(
  getAddedValuesOpenPlatformState,
  getPumpabilities,
  (addedValues, pumpabilities) => {
    return { availableVaps: addedValues.availableAddedValues, pumpabilities };
  },
);

export const getAvailableLegacyVapsAndProducts = createSelector(
  getAddedValuesState,
  getAvailableProducts,
  (availableAddedValues, availableProducts) => {
    return { availableAddedValues, availableProducts };
  },
);

export const getAvailableOPVapsAndProductsRMXUL = createSelector(
  getAvailableOpenPlatformAddedValues,
  getOpenPlatformProducts,
  (availableAddedValues, availableProducts) => {
    return { availableAddedValues, availableProducts };
  },
);

export const valueAddedSpecializedPlatformAddedValues = (index: number) => {
  return createSelector(getAddedValuesOpenPlatformState, (state) => state.valueAddedsWithoutDco[index]);
};

export const productAddedValues = (productCode: number) => {
  return createSelector(getAvailableAddedValues, (availables) => {
    return availables[productCode];
  });
};

export const getOpenPlatformProductAddedValues = (contractCodeKeyName: string) => {
  return createSelector(getAvailableOpenPlatformAddedValues, (availables) => {
    return availables[contractCodeKeyName];
  });
};

export const getOPProductVAPAndUnloadTypes = (contractCodeKeyName: string) => {
  return createSelector(getAvailableOpenPlatformAddedValues, getUnloadTypes, (availables, unloadTypes) => {
    return { availables: availables[contractCodeKeyName], unloadTypes };
  });
};

export const getVAPAndFilteredUnloadTypes = (contractCodeKeyName: string) => {
  return createSelector(getAvailableOpenPlatformAddedValues, getFilteredUnloadTypes, (availables, unloadTypes) => {
    return { availables: availables[contractCodeKeyName], unloadTypes };
  });
};

export const getTemperatureVaps = createSelector(getAddedValuesOpenPlatformState, (state) => state.temperatureValues);
